import clsx from 'clsx';
import React from 'react';

import ProfilesList from '../SubscriberDirectory/ProfilesList';
import styles from './styles.module.scss';

const SearchSubscribersList = ({ content }) => {
  return (
    <div id="SearchSubscribersList">
      <div className={clsx(styles.profilesListSection, 'list-section')}>
        <div className={styles.profilesListWrapper}>
          <ProfilesList
            currentUserId={content?.currentUserId}
            navigate={(route: string) => (window.location.href = route)}
            onSearchPage
            profiles={content || []}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchSubscribersList;
